import React, { useState } from "react";

import ReviewsLists from "./reviewLists";
import ReviewsFilters from "./reviewfilters.jsx";
import { useMutation, useQuery } from "react-query";
import { deleteReviews, getReviews } from "../../../MyApi/reviews/index.js";
import Can from "../../../utils/can/index.jsx";

const Reviews = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({
    search: "",
    status: "",
    date: "",
    rating: "",
  });
  const { data, isLoading ,error ,refetch } = useQuery(["getReviewsUsers" ,filters ,currentPage], () =>
    getReviews(currentPage, filters)
  );

  const reviews = data?.data?.reviews || [];
  const total = data?.data?.pagination?.total || 0;
  const itemsPerPage = data?.data?.pagination.last_page || 0;

  return (
    <Can permission={"view_review"}>
    <main>
     <ReviewsFilters filters={filters} setFilters={setFilters} />
      <ReviewsLists
        reviews={reviews}
        isLoading={isLoading}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        itemsPerPage={itemsPerPage}
        total={total}
        refetch={refetch}
      />
    </main>
      </Can>

  ); 
};

export default Reviews;
